import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import {
  METHODICAL_CONTENT_FETCH_COMPLETED,
  METHODICAL_FETCH_COMPLETED,
  NETWORK_REQUEST_SENT,
} from "./types";
import { checkAndUpdateToken } from "./auth";
import { createNotification } from "../components/notifications/notifications";

export const methodical = (facultyId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      // `${BACKEND_URL_PREFIX}/methodical/${facultyId}/${getState().auth.mid}`,
      `${BACKEND_URL_PREFIX}/methodical/${facultyId}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: METHODICAL_FETCH_COMPLETED,
        methodical: result.methodical,
      });
    }
  }
};

export const content = (facultyId, mrId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/methodical/${facultyId}/${mrId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: METHODICAL_CONTENT_FETCH_COMPLETED, content: result });
    }
  }
};

const fetchFileBlob = async (dispatch, getState, mrId, filename) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return null;

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/methodical/${mrId}/${encodeURIComponent(filename)}`,
    buildDefaultHeaders(getState)
  );
  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (!response.ok) {
    // 401/403/503 обрабатывает requestMiddleware; остальное иначе молча теряется
    createNotification('error', 'Не удалось получить файл', `${filename} (код ${response.status})`);
    return null;
  }
  return response.blob();
};

export const file = (facultyId, mrId, filename) => async (dispatch, getState) => {
  const data = await fetchFileBlob(dispatch, getState, mrId, filename);
  if (!data) return;
  // eslint-disable-next-line
  const fileDownload = require("js-file-download");
  fileDownload(data, filename);
};

export const openFile = (facultyId, mrId, filename) => async (dispatch, getState) => {
  const data = await fetchFileBlob(dispatch, getState, mrId, filename);
  if (!data) return;
  const url = window.URL.createObjectURL(data);
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) {
    // Всплывающее окно заблокировано — отдаём файл на скачивание
    // eslint-disable-next-line
    const fileDownload = require("js-file-download");
    fileDownload(data, filename);
  }
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};
